/**
 * Utility functions for handling AI extraction results
 */

const AI_EXTRACTION_KEY = 'crm_ai_extraction_results';

/**
 * Save AI extraction results to localStorage
 * @param {Object} data - The extraction data
 * @param {string} leadId - The ID of the lead
 */
export const saveExtractionResults = (data, leadId) => {
  if (!data || !leadId) return;
  
  // Create a unique timestamp with milliseconds - this ensures each extraction
  // has a unique identifier even if multiple extractions happen in quick succession
  const timestamp = new Date().toISOString() + '-' + Math.random().toString(36).substring(2, 10);
  
  const results = {
    data,
    leadId,
    timestamp
  };
  
  localStorage.setItem(AI_EXTRACTION_KEY, JSON.stringify(results));
  console.log('[AI] Saved extraction results to localStorage:', results);
};

/**
 * Get AI extraction results from localStorage
 * @returns {Object|null} The extraction results or null if none exist
 */
export const getExtractionResults = () => {
  const resultsString = localStorage.getItem(AI_EXTRACTION_KEY);
  if (!resultsString) return null;
  
  try {
    return JSON.parse(resultsString);
  } catch (error) {
    console.error('[AI] Error parsing extraction results:', error);
    return null;
  }
};

/**
 * Clear AI extraction results from localStorage
 */
export const clearExtractionResults = () => {
  localStorage.removeItem(AI_EXTRACTION_KEY);
  console.log('[AI] Cleared extraction results from localStorage');
};
